<template>
  <div class="awardContainer">
    <div
      class="amountBlock"
      v-if="
        type === 'DISCOUNT_NO_CONDITION' || type === 'DISCOUNT_WITH_CONDITION'
      "
    >
      <i18n-n
        :value="awardData.detail.discountAmount | centToYuan"
        format="currency"
        :locale="$locale"
      >
        <template v-slot:currency="slotProps">
          <span class="unit">{{ slotProps.currency }}</span>
        </template>
        <template v-slot:integer="slotProps">
          <span class="amount">{{ slotProps.integer }}</span>
        </template>
        <template v-slot:fraction="slotProps">
          <span class="amount">{{ slotProps.fraction }}</span>
        </template>
      </i18n-n>
    </div>
    <div class="amountBlock" v-if="type === 'DISCOUNT_BY_RATE'">
      <span class="amount">{{ 100 - awardData.detail.discountRate }}</span
      ><span class="unit">%</span>OFF
    </div>
  </div>
</template>

<script>
import { centToYuan } from '../../helper';
// 折扣类型，1-立减券;2-折扣券 3-满减券
const COUPON_DICOUNT_TYPE = {
  1: 'DISCOUNT_NO_CONDITION',
  2: 'DISCOUNT_BY_RATE',
  3: 'DISCOUNT_WITH_CONDITION'
};

export default {
  computed: {
    type() {
      if (
        this.awardData.detail.discountType === 1 &&
        (this.awardData.detail.thresholdAmount ||
          this.awardData.detail.reachFen)
      ) {
        return COUPON_DICOUNT_TYPE[3];
      }
      return COUPON_DICOUNT_TYPE[this.awardData.detail.discountType];
    }
  },
  filters: {
    centToYuan
  },
  props: {
    awardData: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="less" scoped>
.awardContainer {
  width: 100%;
  height: 100%;
  overflow: hidden;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  line-height: normal;
  color: #fff;
  background: center / cover no-repeat
    url('../../assets/images/lalamove-coupon.png');

  .amountBlock {
    margin-top: -10%;
    color: #fff;
    font-weight: bold;

    .amount {
      font-size: 1em;
      font-family: 'Alibab Zhixing';
    }

    .unit {
      font-size: 0.63em;
    }
  }
}
</style>
